import { Button, Card } from "antd";
import "./blog-item.less";
import { Typography } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import imgEmpty from '~/assets/logo/empty.png'
import { useTranslation } from "react-i18next";
const { Title, Text } = Typography;

const BlogItem = ({ data }) => {
    const { t } = useTranslation('blog');
    const navigate = useNavigate();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const navigateDetailBlog = (documentId) => {
        navigate(`/blog/${documentId}`);
        setTimeout(() => {
            scrollToTop()
        }, 100);
    };
    return (
        <Card className="blog-item-card" hoverable 
            onClick={() => navigateDetailBlog(data.documentId)}
            cover={
                <img
                    className="blog-item-image"
                    src={data?.image?.url || imgEmpty}
                    alt="Blog Thumbnail"
                />
            }>
            <div className="blog-item-content">
                <Title className="blog-item-title" level={4} style={{ margin: 0 }}>{data.title}</Title>
                <Text className="blog-item-desc">
            {data.shortDesc}
                </Text>
                <Text style={{color: '#FBAD16'}}>{t('blog.read_more')}</Text>
            </div>
        </Card>
    );
};

export default BlogItem;
